/* import __COLOCATED_TEMPLATE__ from './thumbnail-manager.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-fields-thumbnail-manager';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_ERROR = `${CLASS_NAME}--error`;
const CLASS_NAME_HOVER = `${CLASS_NAME}--hover`;
const CLASS_NAME_LABELED = `${CLASS_NAME}--labeled`;
const CLASS_NAME_LOADING = `${CLASS_NAME}--loading`;

const MIME_TYPES = [
  'image/bmp',
  'image/gif',
  'image/png',
  'image/jpg',
  'image/jpeg',
];

/** @type {object} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
};

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

/** @class */
class GlmThumbnailManager extends Component {
  @tracked fileInputElement = null;
  @tracked isHoveringIcon = false;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
      this.isDisabled && CLASS_NAME_DISABLED,
      this.args.error && CLASS_NAME_ERROR,
      this.showHover && CLASS_NAME_HOVER,
      this.args.label && CLASS_NAME_LABELED,
      this.args.isLoading && CLASS_NAME_LOADING,
      this.theme,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get isDisabled() {
    return Boolean(this.args.isLoading || this.args.disabled);
  }

  get loaderHexColor() {
    if (this.args.loaderHexColor) {
      return this.args.loaderHexColor;
    }

    switch(this.theme) {
      case THEMES.BLACK:
        return '#DDDDDD';
      case THEMES.WHITE:
        return '#FCFCFC';
      default:
        return '#DDDDDD';
    }
  }

  get mimeTypes() {
    return MIME_TYPES.join(', ');
  }

  get showHover() {
    return Boolean(
      !this.isDisabled
      && !this.args.uploaded
      && this.isHoveringIcon
    );
  }

  get theme() {
    const { theme } = this.args;
    return THEME_TO_CLASS_MAP[theme || THEMES.BLACK];
  }

  @action
  initFileInput(element) {
    this.fileInputElement = element;
  }

  @action
  onClick(e) {
    // prevent accessibility from getting around our restrictions
    if (this.args.imageSrc) {
      e.preventDefault();
      return;
    }

    this.args.onclick?.();
  }

  /**
   *
   */
  @action
  onMouseEnterIconArea() {
    this.isHoveringIcon = true;

    this.args.mouseenter?.();
  }

  /**
   *
   */
  @action
  onMouseLeaveIconArea() {
    this.isHoveringIcon = false;

    this.args.mouseleave?.();
  }

  /**
   * @param {string} id
   */
  @action
  triggerFileInput() {
    // trigger the hidden file input
    this.fileInputElement.click();

    this.args.onclick?.();
  }
}

export default GlmThumbnailManager;
